import { Anchor, Text } from '@mantine/core';

import { Trans, useTranslation } from 'i18n';

export default function Terms() {
  const { t: translateUserAuth } = useTranslation('userAuth');

  return (
    <Text variant="sublabel-xs" ta="center">
      <Trans
        i18nKey="Terms.agreement"
        t={translateUserAuth}
        components={{
          restaurantAgreementLink: (
            <Anchor size="xs" href="https://get.chownow.com/registermyresto" />
          ),
          privacyPolicyLink: <Anchor size="xs" href="https://get.chownow.com/privacy-policy" />,
        }}
      />
    </Text>
  );
}
